export const getPaymentList = variables => ({
  operationName: 'LP_GetPaymentProperties',
  variables,
  query: `
    query LP_GetPaymentProperties(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertySortBy,
      $sortDirection: SortDirection
    ) {
      viewer {
        ... on LandlordContact {
          company {
            properties(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              sortBy: $sortBy,
              sortDirection: $sortDirection
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  id
                  name
                  status
                  currency
                  paymentsEnabled
                  paymentsEnabledAt
                  paymentProcess
                  connectedAccountId
                  paymentDepositRules {
                    edges {
                      node {
                        id
                        name
                        type
                        value
                        paymentProcessingFee
                        firstInstalment
                      }
                    }
                  }
                  paymentTermsAndConditions {
                    edges {
                      node {
                        id
                        title
                        url
                        validFrom
                        validTill
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
});

export const searchUniversity = variables => ({
  operationName: 'Dashboard_Search',
  variables,
  query: `
    query Dashboard_Search($query: String, $pageNumber: Int, $pageSize: Int) {
      search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: PUBLISHED) {
        totalCount
        edges {
          node {
            ... on University{
              id
              published
              name
              slug
            }
          }
        }
      }
    }
  `,
});

export const searchCountry = variables => ({
  operationName: 'Dashboard_Search',
  variables,
  query: `
    query Dashboard_Search($query: String, $pageNumber: Int, $pageSize: Int, $bookingJourneys: [BookingJourney]) {
      search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: ALL, bookingJourneys: $bookingJourneys) {
        totalCount
        edges {
          node {
            ... on Country{
              id
              name
              slug
            }
          }
        }
      }
    }`,
});

export const searchCity = variables => ({
  operationName: 'Dashboard_Search',
  variables,
  query: `
    query Dashboard_Search($query: String, $pageNumber: Int, $pageSize: Int, $bookingJourneys: [BookingJourney]) {
      search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: ALL, bookingJourneys: $bookingJourneys) {
        totalCount
        edges {
          node {
            ... on City{
              id
              name
              slug
            }
          }
        }
      }
    }`,
});

export const getLandLordSimpleProperties = variables => ({
  operationName: 'LP_LandLordSimpleProperties',
  variables: {
    pageNumber: 1,
    pageSize: 9999,
    ...variables,
  },
  query: `
    query LP_LandLordSimpleProperties(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertySortBy,
      $sortDirection: SortDirection,
      $bookingJourneys: [BookingJourney!]
    ) {
      viewer {
        ... on LandlordContact {
          properties(
            pageSize: $pageSize,
            pageNumber: $pageNumber,
            sortBy: $sortBy,
            sortDirection: $sortDirection,
            bookingJourneys: $bookingJourneys
          ) {
            edges {
              node {
                id
                name
                slug
                currency
                status
                bookingJourney
                apCategory
                city {
                  country {
                    name
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }`,
});

export const paymentMutations = {
  updateProperty: inputName => `
    updateProperty(input: ${inputName}) {
      property {
        id
      }
    }
  `,

  createPaymentDeposit: inputName => `
    createPaymentDepositRule(input: ${inputName}) {
      paymentDepositRule {
        id
      }
    }
  `,

  updatePaymentDeposit: inputName => `
    updatePaymentDepositRule(input: ${inputName}) {
      paymentDepositRule {
        id
      }
    }
  `,

  deletePaymentDeposit: inputName => `
    deletePaymentDepositRule(input: ${inputName}) {
      deletedPaymentDepositRuleId
    }
  `,

  createPaymentsTermsAndConditions: inputName => `
    createPaymentsTermsAndConditions(input: ${inputName}) {
      termsAndConditions {
        id
      }
    }  
  `,

  updatePaymentsTermsAndConditions: inputName => `
    updatePaymentsTermsAndConditions(input: ${inputName}) {
      termsAndConditions {
        id
      }
    }  
  `,

  deletePaymentsTermsAndConditions: inputName => `
    deletePaymentsTermsAndConditions(input: ${inputName}) {
      deletedPaymentsTermsAndConditionsId
    }  
  `,
};

/**
 * {
 *  "authCode": "abc123"
 * }
 * @param variables
 */
export const createConnectedAccount = variables => ({
  operationName: 'LP_CreateConnectedAccount',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_CreateConnectedAccount($input: createConnectedAccountInput!) {
      createConnectedAccount(input: $input) {
        connectedAccountId
      }
    }`,
});

/**
 * {
 *  "id": "sdfsdfsd1234",
 *  "paymentProcess": "ONLINE/OFFLINE"
 * }
 * @param variables
 */
export const updatePaymentProcess = ({ ids, paymentProcess }) => {
  const inputParams = [];
  const mutationQueries = [];
  const variables = {};

  ids.map((id, index) => {
    inputParams.push(`$input${index}: UpdatePropertyInput`);
    variables[`input${index}`] = {
      id,
      paymentProcess,
    };

    mutationQueries.push(`
      mutation${index}: updateProperty(input: $input${index}) {
        property {
          id
        }
      }
    `);
    return true;
  });

  return {
    operationName: 'LP_UpdatePaymentProcess',
    variables,
    query: `
    mutation LP_UpdatePaymentProcess(${inputParams.join(', ')}) {
      ${mutationQueries.join(' ')}
    }`,
  };
};

export const getLandlordType = () => ({
  operationName: 'LP_GetLandlordType',
  query: `
    query LP_GetLandlordType {
      viewer {
        ... on LandlordContact {
          accountLevel
          company {
            allowNoPayment
            isLongtail
            billingCountry {
              id
              name
              slug
            }
            id
            name
            slug
            reconciliationOption
            status
            accountDifferentiation
          } 
        }
      }
    }
  `,
});

export const getLongtailBookingsListings = variables => ({
  operationName: 'LP_GetLongtailBookingsListings',
  variables,
  query: `
    query LP_GetLongtailBookingsListings(
      $pageNumber: PositiveInteger = 1,
      $pageSize: PositiveInteger = 10,
      $statuses: [BookingStatus!],
      $landlordBookingStatuses: [LandlordBookingStatus!],
      $propertyNodeId: ID,
      $createdBefore: Date,
      $createdAfter: Date,
      $moveInBefore: Date,
      $moveInAfter: Date,
      $sortBy: BookingSortBy,
      $sortDirection: BookingSortDirection,
      $referenceId: String
    ) {
      viewer {
        ... on LandlordContact {
          company {
            bookings(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              statuses: $statuses,
              landlordBookingStatuses: $landlordBookingStatuses,
              propertyNodeId: $propertyNodeId,
              createdBefore: $createdBefore,
              createdAfter: $createdAfter,
              moveInBefore: $moveInBefore,
              moveInAfter: $moveInAfter,
              sortBy: $sortBy,
              sortDirection: $sortDirection,
              referenceId: $referenceId
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  id
                  unitType {
                    name
                  }
                  currency
                  student {
                    firstName
                    lastName
                    firstNameAlt
                    lastNameAlt
                    nameAlt
                    passportFirstName
                    passportLastName
                    passportMiddleName
                    dateOfBirth
                    emailAddress
                    phoneNumber
                    nationality
                    wechatId
                  }
                  property {
                    name
                    currency
                    billingCycle
                  }
                  status
                  moveInDate
                  moveOutDate
                  createdAt
                  completedAt
                  price
                  referenceId
                  invoice {
                    studentOutstandingBalance
                    landlordOutstandingBalance
                    scomOutstandingBalance
                    lineItems {
                      studentSubTotal
                      landlordSubTotal
                      scomSubTotal
                      edges {
                        node {
                          benefactor
                          beneficiary
                          amount
                          description
                          currency
                          paymentType
                        }
                      }
                    }
                    payments {
                      studentSubTotal
                      landlordSubTotal
                      scomSubTotal
                      edges {
                        node {
                          benefactor
                          beneficiary
                          amount
                          description
                          currency
                          paymentType
                        }
                      }
                    }
                    transferSchedules {
                      paymentType
                      scheduleType
                      lineItems {
                        benefactor
                        beneficiary
                        amount
                        description
                        currency
                        paymentType
                      }
                      landlordSubTotal
                    }
                  }
                  process {
                    edges {
                      node {
                        ... on DepositPaymentStep {
                          updatedAt
                          status
                          type
                        }
                        ... on FirstInstalmentPaymentStep {
                          updatedAt
                          status
                          type
                        }
                        ... on LandlordPreApprovalStep {
                          status
                          updatedAt
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
});

export const getPBSABookingsListings = variables => ({
  operationName: 'LP_GetPBSABookingsListings',
  variables,
  query: `
    query LP_GetPBSABookingsListings(
      $pageNumber: PositiveInteger = 1,
      $pageSize: PositiveInteger = 10,
      $statuses: [BookingStatus!],
      $landlordBookingStatuses: [LandlordBookingStatus!],
      $propertyNodeId: ID,
      $createdBefore: Date,
      $createdAfter: Date
      $moveInBefore: Date,
      $moveInAfter: Date,
      $completedAtBefore: Date,
      $completedAtAfter: Date,
      $moveOutBefore: Date,
      $moveOutAfter: Date,
      $sortBy: BookingSortBy,
      $sortDirection: BookingSortDirection,
      $referenceId: String
    ) {
      viewer {
        ... on LandlordContact {
          company {
            bookings(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              statuses: $statuses,
              landlordBookingStatuses: $landlordBookingStatuses,
              propertyNodeId: $propertyNodeId,
              createdBefore: $createdBefore,
              createdAfter: $createdAfter
              moveInBefore: $moveInBefore,
              moveInAfter: $moveInAfter,
              completedAtBefore: $completedAtBefore,
              completedAtAfter: $completedAtAfter,
              moveOutBefore: $moveOutBefore,
              moveOutAfter: $moveOutAfter,
              sortBy: $sortBy,
              sortDirection: $sortDirection,
              referenceId: $referenceId
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  id
                  unitType {
                    name
                  }
                  currency
                  student {
                    firstName
                    lastName
                    firstNameAlt
                    lastNameAlt
                    nameAlt
                    passportFirstName
                    passportLastName
                    passportMiddleName
                    dateOfBirth
                    emailAddress
                    phoneNumber
                    nationality
                    wechatId
                  }
                  property {
                    name
                    currency
                    billingCycle
                  }
                  landlordBookingStatus
                  moveInDate
                  moveOutDate
                  createdAt
                  completedAt
                  price
                  referenceId
                  landlordApplicationId
                  comments {
                    id
                    content
                    createdAt
                    createdByName
                    createdByType
                  }
                  commission {
                    bonusValue
                    bonusCalculationValue
                    bonusCalculationType
                    calculationValue
                    calculationType
                    total
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
});

export const getLongtailLandlordSummary = variables => ({
  operationName: 'LP_GetLandlordSummary',
  variables,
  query: `
    query LP_GetLandlordSummary(
      $propertyNodeId: ID,
      $createdBefore: Date,
      $createdAfter: Date,
      $moveInBefore: Date,
      $moveInAfter: Date,
      $completedAtBefore: Date,
      $completedAtAfter: Date,
      $moveOutBefore: Date,
      $moveOutAfter: Date,
      $referenceId: String
    ) {
      viewer {
        ... on LandlordContact {
          company {
            bookings(
              pageSize: 99999,
              pageNumber: 1,
              statuses: [APPLICATION_PROCESSING, COMPLETED]
              propertyNodeId: $propertyNodeId,
              createdBefore: $createdBefore,
              createdAfter: $createdAfter,
              moveInBefore: $moveInBefore,
              moveInAfter: $moveInAfter,
              completedAtBefore: $completedAtBefore,
              completedAtAfter: $completedAtAfter,
              moveOutBefore: $moveOutBefore,
              moveOutAfter: $moveOutAfter,
              referenceId: $referenceId
            ) {
              landlordOutstandingBalance
              applicationProcessingCount
              priceTotal
              completedCount
              totalCount
            }
          }
        }
      }
    }
  `,
});

export const getPBSALandlordSummary = variables => ({
  operationName: 'LP_GetPBSALandlordSummary',
  variables,
  query: `
    query LP_GetPBSALandlordSummary(
      $propertyNodeId: ID,
      $createdBefore: Date,
      $createdAfter: Date,
      $moveInBefore: Date,
      $moveInAfter: Date,
      $completedAtBefore: Date,
      $completedAtAfter: Date,
      $moveOutBefore: Date,
      $moveOutAfter: Date,
      $referenceId: String
    ) {
      viewer {
        ... on LandlordContact {
          company {
            summary(
              propertyNodeId: $propertyNodeId,
              createdBefore: $createdBefore,
              createdAfter: $createdAfter,
              moveInBefore: $moveInBefore,
              moveInAfter: $moveInAfter,
              completedAtBefore: $completedAtBefore,
              completedAtAfter: $completedAtAfter,
              moveOutBefore: $moveOutBefore,
              moveOutAfter: $moveOutAfter,
              referenceId: $referenceId
            ) {
              totalValue
              totalCommission
              totalBookings
              readyForApproval
              pendingApproval
              approved
              readyToInvoice
              invoiced
              paid
              currency
            }
          }
        }
      }
    }
  `,
});

export const getLandlordProperties = variables => ({
  operationName: 'LP_GetLandlordProperties',
  variables,
  query: `
    query LP_GetLandlordProperties(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertySortBy,
      $sortDirection: SortDirection
    ) {
      viewer {
        ... on LandlordContact {
          company {
            properties(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              sortBy: $sortBy,
              sortDirection: $sortDirection
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  id
                  name
                  slug
                  currency
                }
              }
            }
          }
        }
      }
    }`,
});

export const getLandlordPropertiesListings = variables => ({
  operationName: 'LP_GetLandlordPropertiesListings',
  variables,
  query: `
    query LP_GetLandlordPropertiesListings(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertySortBy,
      $sortDirection: SortDirection,
      $propertySlug: String,
    ) {
      viewer {
        ... on LandlordContact {
          company {
            properties(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              sortBy: $sortBy,
              sortDirection: $sortDirection,
              propertySlug: $propertySlug,
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  name
                  slug
                  currency
                  billingCycle
                  listings(pageNumber: 1, pageSize: 9999) {
                    edges {
                      node {
                        id
                        priceMin
                        priceMax
                        availability
                        updatedAt
                        discountType
                        discountValue
                        unitType {
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
});

/**
 * {
 *   "listingId": "sdfjskdfs",
 *   "availability": "GOOD",
 *   "maxPrice": 123,
 *   "minPrice": 111,
 *   "discountType": "PERCENTAGE",
 *   "discountValue": 10,
 * }
 * @param variables
 */
export const updateRoomListing = variables => ({
  operationName: 'Landlord_UpdateRoomListing',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_UpdateRoomListing($input: UpdateListingInput!) {
      updateListing(input: $input) {
        listing {
          id
          type
        }
      }
    }`,
});

/**
 * {
 *   "id": "sdfjskdfs",
 * }
 * @param variables
 */
export const completeBooking = variables => ({
  operationName: 'Landlord_CompleteBooking',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_CompleteBooking($input: CompleteBookingInput) {
      completeBooking(input: $input) {
        booking {
          id
        }
      }
    }
  `,
});

/**
 * {
 *   "id": "sdfjskdfs",
 * }
 * @param variables
 */
export const approveBooking = variables => ({
  operationName: 'Landlord_ApproveBooking',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_ApproveBooking($input: ApproveBookingInput) {
      approveBooking(input: $input) {
        booking {
          id
        }
      }
    }
  `,
});

/**
 * {
 *   "id": "###########",
 *   "rejectReason": "***********",
 * }
 * @param variables
 */
export const rejectBooking = variables => ({
  operationName: 'Landlord_RejectBooking',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_RejectBooking($input: RejectBookingInput) {
      rejectBooking(input: $input) {
        booking {
          id
        }
      }
    }
  `,
});

/**
 * {
 *   "bookingId": "sdfjskdfs",
 *   "status": "APPROVED",
 * }
 * @param variables
 */

export const updateLandlordBookingStatus = ({ bookingIds, status }) => {
  const inputParams = [];
  const mutationQueries = [];
  const variables = {};

  bookingIds.map((bookingId, index) => {
    inputParams.push(`$input${index}: updateLandlordBookingStatusInput`);
    variables[`input${index}`] = {
      bookingId,
      status,
    };

    mutationQueries.push(`
      mutation${index}: updateLandlordBookingStatus(input: $input${index}) {
        success
      },
    `);

    return true;
  });

  return {
    operationName: 'Landlord_UpdateLandlordBookingStatus',
    variables,
    query: `
      mutation Landlord_UpdateLandlordBookingStatus(${inputParams.join(', ')}) {
        ${mutationQueries.join(', ')}
      }`,
  };
};

/**
 * {
 *   "bookingId": "asdfasdf",
 *   "content": "comment content",
 * }
 * @param variables
 */
export const createBookingComment = variables => ({
  operationName: 'Landlord_CreateBookingComment',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_CreateBookingComment($input: CreateBookingCommentInput) {
      createBookingComment(input: $input) {
        success
      }
    }`,
});

/**
 * {
 *   "landlordbookingStatus": "APPROVED/READY_TO_INVOICE",
 *   "propertyNodeId": 'sdasdf',
 *   "createdBefore": Date,
 *   "createdAfter": Date,
 * }
 * @param variables
 */
export const batchUpdateLandlordBookingStatus = variables => ({
  operationName: 'Landlord_BatchUpdateLandlordBookingStatus',
  variables: {
    input: variables,
  },
  query: `
    mutation Landlord_BatchUpdateLandlordBookingStatus($input: batchUpdateLandlordBookingStatusInput) {
      batchUpdateLandlordBookingStatus(input: $input) {
        success
      }
    }`,
});

/**
 *
 * @param {object} variables
 *  {
 *    email: "",
 *    password: "",
 *  }
 */
export const login = variables => ({
  operationName: 'LP_Login',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_Login($input: LandlordAccountLoginInput) {
      landlordAccountLogin(input: $input) {
        authToken
      }
    }
  `,
});

/**
 *
 * @param {object} variables
 *  {
 *    email: "",
 *    portal: "",
 *  }
 */
export const resetPassword = variables => ({
  operationName: 'LP_ForgotPassword',
  variables,
  query: `
    mutation LP_ForgotPassword(
      $email: String!, 
      $portal: Portal
    ) {
      forgotPassword(email: $email, portal: $portal) {
        success
      }
    }
  `,
});

/**
 *
 * @param {object} variables
 *  {
 *    newPassword: "",
 *    portal: "",
 * token: "",
 *  }
 */
export const setPassword = variables => ({
  operationName: 'LP_SetPassword',
  variables,
  query: `
  mutation LP_SetPassword($newPassword: String!, $portal: Portal, $token: String!) {
    resetPassword(newPassword: $newPassword, portal: $portal, token: $token) {
      success
    }
  }
  `,
});

export const checkLandlordAccountExist = variables => ({
  operationName: 'LP_CheckLandlordAccountExist',
  variables,
  query: `
    query LP_CheckLandlordAccountExist(
      $email: NonEmptyString,
    ) {
      checkLandlordAccountExist(
        email: $email,
    ) {
      exist
      enabled
    }
  }`,
});

export const getLongtailPaymentPlan = variables => ({
  operationName: 'LP_GetLongtailPaymentPlan',
  variables,
  query: `
    query LP_GetLongtailPaymentPlan($id: ID!) {
      getPaymentPlan(id: $id) {
        paymentPlan {
          paymentOnline
          category
          currency
          description
          endDate
          id
          landlordId
          landlord {
            id
          }
          name
          properties {
            id
            name
            slug
            status
            bookingJourney
          }
          startDate
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          fees{
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          instalments {
            createdAt
            fromTenancy
            id
            payMonthly
            payQuarterly
            payWeekly
            country{
              name
            }
            payRemainderAtOnce
            fullPayment
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            payNowAmount
            updatedAt
          }
        }
      }
  }`,
});

export const createLongtailPaymentPlan = variables => ({
  operationName: 'LP_CreateLongtailPaymentPlan',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_CreateLongtailPaymentPlan($input: CreatePaymentPlanInput) {
      createPaymentPlan(input: $input) {
        paymentPlan {
          paymentOnline
          category
          currency
          description
          endDate
          id
          landlordId
          name
          properties {
            id
            name
            slug
          }
          startDate
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
          }
          fees{
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
          }
          instalments {
            createdAt
            fromTenancy
            fullPayment
            id
            payMonthly
            payQuarterly
            fullPayment
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            updatedAt
          }
        }
      }
  }`,
});

export const updateLongtailPaymentPlan = variables => ({
  operationName: 'LP_UpdateLongtailPaymentPlan',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_UpdateLongtailPaymentPlan($input: UpdatePaymentPlanInput) {
      updatePaymentPlan(input: $input) {
        paymentPlan {
          currency
          description
          endDate
          id
          landlordId
          name
          properties {
            id
            name
            slug
            status
            bookingJourney
          }
          startDate
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
          }
          fees{
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
          }
          instalments {
            createdAt
            fromTenancy
            fullPayment
            id
            payMonthly
            payQuarterly
            payWeekly
            country{
              name
            }
            payRemainderAtOnce
            
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            payNowAmount
            updatedAt
          }
        }
      }
  }`,
});

export const createOrderDeposit = variables => ({
  operationName: 'LP_CreateOrderDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_CreateOrderDeposit($input: CreateOrderDepositInput) {
      createOrderDeposit(input: $input) {
        orderDeposit {
          amount
          currency
          description
          id
          name
          paymentPlanId
          paymentType
          payThroughStcom
        }
      }
  }`,
});

export const deleteOrderDeposit = variables => ({
  operationName: 'LP_DeleteOrderDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_DeleteOrderDeposit($input: DeleteOrderDepositInput) {
      deleteOrderDeposit(input: $input) {
        orderDeposit {
          id
        }
      }
  }`,
});

export const updateOrderDeposit = variables => ({
  operationName: 'LP_UpdateOrderDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_UpdateOrderDeposit($input: UpdateOrderDepositInput) {
      updateOrderDeposit(input: $input) {
        orderDeposit {
          amount
          currency
          description
          id
          name
          paymentPlanId
          paymentType
          payThroughStcom
        }
      }
  }`,
});

export const createOrderFee = variables => ({
  operationName: 'LP_CreateOrderFee',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_CreateOrderFee($input: CreateOrderFeeInput) {
      createOrderFee(input: $input) {
        orderFee {
          amount
          currency
          description
          id
          name
          paymentPlanId
          paymentType
          payThroughStcom
        }
      }
  }`,
});

export const deleteOrderFee = variables => ({
  operationName: 'LP_DeleteOrderFee',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_DeleteOrderFee($input: DeleteOrderFeeInput) {
      deleteOrderFee(input: $input) {
        orderFee {
          id
        }
      }
  }`,
});

export const updateOrderFee = variables => ({
  operationName: 'LP_UpdateOrderFee',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_UpdateOrderFee($input: UpdateOrderFeeInput) {
      updateOrderFee(input: $input) {
        orderFee {
          amount
          currency
          description
          id
          name
          paymentPlanId
          paymentType
          payThroughStcom
        }
      }
  }`,
});

export const checkLandlordExist = variables => ({
  operationName: 'LP_CheckLandlordExist',
  variables,
  query: `
    query LP_CheckLandlordExist(
      $type: LoginType!
      $value: String!
    ) {
      checkLandlordExist(
        type: $type,
        value: $value,
    ) {
      exist
      enabled
    }
  }`,
});

const withdrawMethodItem = `
id
name
methodType
properties {
  id
  name
  slug
  currency
}
updatedAt
updatedBy {
  firstName
  lastName
}
virtualCreditCards {
  email
}
stripes {
  stripeId
}
bankTransfers {
  data
}
`;

export const getWithdrawalMethods = () => ({
  operationName: 'LP_GetWithdrawalMethods',
  variables: {
    pageNumber: 1,
    pageSize: 9999,
  },
  query: `
    query LP_GetWithdrawalMethods(
      $pageNumber: PositiveInteger,
      $pageSize: PositiveInteger 
    ) {
      listWithdrawMethods(
        pageSize: $pageSize,
        pageNumber: $pageNumber,
      ) {
        edges {
          node{
            ${withdrawMethodItem}
          }
        }
      }
    }
  `,
});

export const deleteWithdrawalMethod = variables => ({
  operationName: 'LP_DeleleWithdrawalMethod',
  variables,
  query: `
    mutation LP_DeleleWithdrawalMethod($input: deleteWithdrawMethodInput) {
      deleteWithdrawMethod(input: $input) {
        withdrawMethod {
          ${withdrawMethodItem}
        }
      }
    }  
  `,
});

export const addWithdrawalMethod = variables => ({
  operationName: 'LP_AddWithdrawalMethod',
  variables,
  query: `
    mutation LP_AddWithdrawalMethod($input: createWithdrawMethodInput) {
      createWithdrawMethod(input: $input) {
        withdrawMethod {
          ${withdrawMethodItem}
        }
      }
    }
  `,
});

export const updateWithdrawalMethod = variables => ({
  operationName: 'LP_UpdateWithdrawalMethod',
  variables,
  query: `
    mutation LP_UpdateWithdrawalMethod($input: updateWithdrawMethodInput) {
      updateWithdrawMethod(input: $input) {
        withdrawMethod {
          ${withdrawMethodItem}
        }
      }
    } 
  `,
});

export const getStripeId = variables => ({
  operationName: 'LP_GetStripeId',
  variables,
  query: `
    mutation LP_GetStripeId($input: createConnectedAccountInput!) {
      createConnectedAccount(input: $input) {
        connectedAccountId
      }
    } 
  `,
});

export const createLongtailOrderInstalment = variables => ({
  operationName: 'LP_CreateLongtailOrderInstalment',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_CreateLongtailOrderInstalment($input: CreateOrderInstalmentInput) {
      createOrderInstalment(input: $input) {
        orderInstalment {
          createdAt
          fromTenancy
          id
          payMonthly
          payQuarterly
          fullPayment
          name
          paymentPlanId
          requireGuarantor
          tenancyUnit
          toTenancy
          updatedAt
        }
      }
  }`,
});

export const updateLongtailOrderInstalment = variables => ({
  operationName: 'LP_UpdateLongtailOrderInstalment',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_UpdateLongtailOrderInstalment($input: UpdateOrderInstalmentInput) {
      updateOrderInstalment(input: $input) {
        orderInstalment {
          createdAt
          fromTenancy
          id
          payMonthly
          payQuarterly
          fullPayment
          name
          paymentPlanId
          requireGuarantor
          tenancyUnit
          toTenancy
          updatedAt
        }
      }
  }`,
});

export const deleteLongtailOrderInstalment = variables => ({
  operationName: 'LP_DeleteLongtailOrderInstalment',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_DeleteLongtailOrderInstalment($input: DeleteOrderInstalmentInput) {
      deleteOrderInstalment(input: $input) {
        orderInstalment {
          createdAt
          fromTenancy
          id
          payMonthly
          payQuarterly
          fullPayment
          name
          paymentPlanId
          requireGuarantor
          tenancyUnit
          toTenancy
          updatedAt
        }
      }
  }`,
});

export const getLongtailPaymentList = variables => ({
  operationName: 'LP_GetLontailPaymentPlans',
  variables,
  query: `query LP_GetLontailPaymentPlans(
    $currency: String,
    $pageNumber: PositiveInteger,
    $pageSize: PositiveInteger,
    $sortBy: SortBy,
    $sortDirection: SortDirection
  ) {
    paymentPlans(
      currency: $currency,
      pageSize: $pageSize,
      pageNumber: $pageNumber,
      sortBy: $sortBy,
      sortDirection: $sortDirection
    ) {
      edges {
        node {
          category
          active
          id
          name
          currency
          hasIntegratedProperty
          deposits {
            id
          }
          fees {
            id
          }
          instalments {
            id
          }
          properties {
            id
            name
            slug
            status
          }
          startDate
          endDate
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }`,
});

export const deleteLongtailPayment = variables => ({
  operationName: 'LP_DeleteLongtailPayment',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_DeleteLongtailPayment($input: deletePaymentPlanInput) {
      deletePaymentPlan(input: $input) {
        paymentPlan {
          id
        }
      }
    }`,
});

export const getLongtailPaymentListProperties = variables => ({
  operationName: 'LP_GetLontailPaymentPlansProperties',
  variables,
  query: `query LP_GetLontailPaymentPlansProperties(
    $pageNumber: PositiveInteger,
    $pageSize: PositiveInteger,
    $sortBy: SortBy,
    $sortDirection: SortDirection
  ) {
    paymentPlans(
      pageSize: $pageSize,
      pageNumber: $pageNumber,
      sortBy: $sortBy,
      sortDirection: $sortDirection
    ) {
      edges {
        node {
          properties {
            id
            name
            slug
            status
          }
        }
      }
    }
  }`,
});

export const getLongtailBookingDetail = variables => ({
  operationName: 'LP_GetLongtailBookingDetail',
  variables,
  query: `query LP_GetLongtailBookingDetail(
    $referenceId: String,
  ) {
    viewer {
      ... on LandlordContact {
        company {
          orders(referenceId: $referenceId) {
            edges {
              node {
                landlordConfirmedPayment
                paymentOnline
                externalId
                id
                moveInDate
                moveOutDate
                referenceId
                billingCycle
                bookingJourney
                currency
                cancelledReason
                paidAt
                city {
                  id
                  name
                  country{
                    slug
                  }
                  slug
                }
                passportFirstName
                passportLastName
                paymentDuration
                confirmationDuration
                uploadFiles {
                  name
                  id
                  source
                  type
                }
                landlord {
                  name
                }
                student {
                  lastName
                  firstName
                  passportFirstName
                  passportLastName
                  phoneNumber
                  emailAddress
                  gender
                  dateOfBirth
                  country
                  state
                  city
                  addressLines
                  postalCode
                  nationality
                  currentUniversity
                  destinationUniversity
                  studyMajor
                  academicYear
                  userUuid
                }
                guarantor {
                  addressLines
                  city
                  country
                  state
                  dateOfBirth
                  emailAddress
                  firstName
                  lastName
                  phone
                  postalCode
                  gender
                  relationshipWithStudent
                }
                listingId
                instalmentPlanType
                propertyName
                propertyId
                unitTypeId
                unitTypeName
                unitTypeCategory
                listingSalesPrice
                totalPrice
                totalRental
                totalFee
                totalDeposit
                secondaryStage
                counterOffers {
                  discountValue
                  discountType
                  currency
                  listingId
                  stage
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  unitTypeName
                  totalPrice
                  currency
                  listingSalesPrice
                  billingCycle
                  totalPrice
                  validPeriodHour
                  createdAt
                  updatedAt
                  rejectReason
                  instalmentPlanType
                  rejectReason
                  stage
                  property {
                    status
                    name
                    address
                    slug
                    bookingJourney
                    city {
                     id
                     name
                     slug
                      country{
                      slug
                      }
                    }
                    paymentPlan{
                      paymentOnline
                    }
                    addressLine2
                    documentations {
                      name
                      check
                      slug
                    }
                  }
                  originOrder {
                    billingCycle
                    currency
                    id
                    property {
                      status
                      name
                      slug
                      bookingJourney
                      city {
                        id
                        name
                        country{
                          slug
                        }
                        slug
                      }
                      address
                      addressLine2
                    }
                    instalmentPlanType
                    listingDiscountType
                    listingDiscountValue
                    listingId
                    listingMaxPrice
                    listingMinPrice
                    listingMoveIn
                    listingMoveInType
                    listingMoveOut
                    listingMoveOutType
                    listingSalesPrice
                    listingTenancyLengthType
                    listingTenancyLengthValue
                    moveInDate
                    moveOutDate
                    totalDeposit
                    totalFee
                    totalRental
                    totalPrice
                    unitTypeCategory
                    unitTypeId
                    unitTypeName
                  }
                }
                stage
                charges {
                  id
                  referenceId
                  chargeAmount
                  chargeCurrency
                  paymentMethod
                  tradeNo
                  stripeChargeId
                }
                payments {
                  amount
                  currency
                  id
                  name
                  paymentCategory
                  updatedAt
                  payThroughStcom
                  price
                  status
                  orderChargeId
                }
                processes {
                  modifierName
                  currentStage
                  updatedAt
                  currentSecondaryStage
                }
                refunds {
                  id
                  referenceId
                  refundType
                  refundMethod
                  status
                  amount
                  currency
                  refundFrom
                  refundTo
                  refundedAt
                  refundMethodDetails
                  transactionNo
                  isTransferred
                  processes {
                    createdAt
                    currentStatus
                  }
                }
                commissions {
                  basePrice
                  bonusCommissionTierType
                  bonusCommissionTierValue
                  bonusPrice
                  commissionTierType
                  commissionTierValue
                  createdAt
                  currency
                  id
                  orderId
                  referenceId
                  status
                  totalPrice
                  updatedAt
                }
                receivables {
                  referenceId
                  receivableType
                  receivableMethod
                  status
                  amount
                  currency
                  invoiceNumber
                  invoicedAt
                  paidAt
                  commission {
                    totalPrice
                    currency
                  }
                }
                transfers {
                  referenceId
                  transferType
                  amount
                  currency
                  status
                  planningTransferDatetime
                  actualTransferDatetime
                  actualTransferDetails
                  actualTransferMethod
                }

                property {
                  status
                  id
                  name
                  slug
                  address
                  bookingJourney
                  addressLine2
                  city {
                    id
                    name
                    country{
                      slug
                    }
                    slug
                  }
                  documentations {
                    name
                    check
                    slug
                  }
                  paymentPlan{
                    paymentOnline
                  }
                  commissionTiers {
                    bonus
                    capType
                    capValue
                    category
                    convertedCalculationValue
                    description
                    fullyCalculatable
                    id
                    name
                    percentageForReport
                    retrospectiveCommission
                    status
                    tenancyLengthFrom
                    tenancyLengthTo
                    tenancyUnit
                    type
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
});

export const getLongtailBookings = variables => ({
  operationName: 'LP_GetLongtailBookings',
  variables,
  query: `
    query LP_GetLongtailBookings(
      $pageNumber: PositiveInteger,
      $pageSize: PositiveInteger,
      $sortBy: OrderSortBy,
      $sortDirection: SortDirection,
      $propertyNodeId: ID,
      $referenceId: String
      $stages: [OrderStage],
      $studentEmail: NonEmptyString,
      $passportFullName: NonEmptyString,
    ) {
      viewer {
        ... on LandlordContact {
          company {
            orders(
              pageSize: $pageSize,
              pageNumber: $pageNumber,
              sortBy: $sortBy,
              sortDirection: $sortDirection,
              propertyNodeId: $propertyNodeId,
              referenceId: $referenceId
              stages: $stages,
              passportFullName: $passportFullName,
              studentEmail: $studentEmail,
            ) {
              pageInfo {
                numPages
              }
              totalCount
              edges {
                node {
                  id
                  stage
                  secondaryStage
                  student {
                    firstName
                    lastName
                    id
                    emailAddress
                    passportFirstName
                    passportLastName
                  }
                  propertyName
                  unitTypeId
                  unitTypeName
                  unitTypeCategory
                  referenceId
                  totalPrice
                  currency
                }
              }
            }
          }
        }
      }
    }
    `,
});

export const confirmOrder = variables => ({
  operationName: 'LP_ConfirmOrder',
  variables: {
    input: variables,
  },
  query: `
      mutation LP_ConfirmOrder(
        $input: ConfirmOrderInput
      ) {
        confirmOrder(
          input: $input,
        ) {
          order {
            id
          }
        }
      }
    `,
});

export const rejectOrder = variables => ({
  operationName: 'LP_RejectOrder',
  variables: {
    input: variables,
  },
  query: `
      mutation LP_RejectOrder(
        $input: RejectOrderInput
      ) {
        rejectOrder(
          input: $input,
        ) {
          order {
            id
          }
        }
      }
    `,
});

export const confirmRefund = variables => ({
  operationName: 'LP_ConfirmRefund',
  variables: {
    input: variables,
  },
  query: `
    mutation LP_ConfirmRefund(
      $input: UpdateOrderRefundStatusInput
    ) {
      landlordRefund(
        input: $input,
      ) {
        orderRefund {
          id
          referenceId
          refundType
          refundMethod
          status
          amount
          currency
          refundFrom
          refundTo
          refundedAt
          refundMethodDetails
          processes {
            createdAt
            currentStatus
          }
        }
      }
    }
  `,
});

export const listLandlordReconciliationOpportunities = variables => ({
  operationName: 'LP_ListLandlordReconciliationOpportunities',
  variables,
  query: `
    query LP_ListLandlordReconciliationOpportunities(
      $finalMoveInDateEnd: VerifyDate,
      $finalMoveInDateStart: VerifyDate,
      $finalMoveOutDateEnd: VerifyDate,
      $finalMoveOutDateStart: VerifyDate,
      $completedAtEnd: Datetime,
      $completedAtStart: Datetime,
      $landlordApplicationIds: [NonEmptyString],
      $landlordBookingStatuses: [LandlordBookingStatus],
      $pageNumber: PositiveInteger,
      $pageSize: PositiveInteger,
      $propertyIds: [ID],
      $xbookingReferenceIds: [NonEmptyString],
      $invoiceNumbers: [NonEmptyString],
      $sortBy: LandlordOpportunitySortBy,
      $sortDirection: SortDirection,
    ) {
      listLandlordReconciliationOpportunities(
        finalMoveInDateEnd: $finalMoveInDateEnd,
        finalMoveInDateStart: $finalMoveInDateStart,
        finalMoveOutDateEnd: $finalMoveOutDateEnd,
        finalMoveOutDateStart: $finalMoveOutDateStart,
        completedAtEnd: $completedAtEnd,
        completedAtStart: $completedAtStart,
        landlordApplicationIds: $landlordApplicationIds,
        landlordBookingStatuses: $landlordBookingStatuses,
        invoiceNumbers: $invoiceNumbers,
        pageNumber: $pageNumber,
        pageSize: $pageSize,
        propertyIds: $propertyIds,
        xbookingReferenceIds: $xbookingReferenceIds,
        sortBy: $sortBy,
        sortDirection: $sortDirection,
      ) {
        pageInfo {
          numPages
        }
        totalCount
        edges {
          node {
            completedAt
            completedXbooking {
              billingCycle
              listingMoveIn
              listingMoveInType
              listingMoveOut
              listingMoveOutType
              propertyName
              referenceId
              roomName
              unitPrice
              commission {
                invoiceNumber
                bonusValue
                currency
                totalCommissionValue
                value
              }
            }
            currency
            finalMoveInDate
            finalMoveOutDate
            finalPrice
            id
            stage
            landlordApplicationId
            landlordBookingStatus
            repeatType
            student {
              dateOfBirth
              destinationUniversity
              emailAddress
              gender
              nationality
              passportFirstName
              passportLastName
              passportMiddleName
              passportNumber
              phoneNumber
            }
          }
        }
      }
    }
    `,
});

export const listLandlordReconciliationOrders = variables => ({
  operationName: 'LP_listLandlordReconciliationOrders',
  variables,
  query: `
    query LP_listLandlordReconciliationOrders(
      $bookingJourney: BookingJourney!
      $citySlug: NonEmptyString
      $countrySlug: NonEmptyString
      $invoiceNumber: NonEmptyString
      $moveInDateStart: String
      $moveInDateEnd: String
      $moveOutDateStart: String
      $moveOutDateEnd: String
      $orderReferenceId: NonEmptyString
      $propertyIds: [ID]
      $receivableStatus: [OrderReceivableStatus]
      $pageNumber: Int = 1
      $pageSize: Int = 10
    ) {
      listDashboardOrderReceivables(
        bookingJourney: $bookingJourney
        citySlug: $citySlug
        countrySlug: $countrySlug
        invoiceNumber: $invoiceNumber
        moveInDateStart: $moveInDateStart
        moveInDateEnd: $moveInDateEnd
        moveOutDateStart: $moveOutDateStart
        moveOutDateEnd: $moveOutDateEnd
        orderReferenceId: $orderReferenceId
        propertyIds: $propertyIds
        receivableStatus: $receivableStatus
        pageNumber: $pageNumber
        pageSize: $pageSize
      ) {
        edges {
          id
          referenceId
          currency
          status
          invoiceNumber
          invoicedAt
          landlord {
            name
            slug
          }
          paidAt
          property {
            name
            listings {
              edges {
                node {
                  id
                  unitType {
                    name
                    price {
                      minPrice
                    }
                  }
                }
              }
            }
          }
          orderReceivableProcesses {
            currentStatus
          }
          order {
            id
            currency
            moveInDate
            moveOutDate
            listingMinPrice
            listingSalesPrice
            listingId
            propertyId
            propertyName
            unitTypeId
            unitTypeName
            totalRental
            completedAt
            createdAt
            paidAt
            referenceId
            student {
              passportFirstName
              passportMiddleName
              passportLastName
              emailAddress
              phoneNumber
            }
            city {
              name
              slug
              country {
                name
                slug
              }
            }
          }
          commission {
            id
            currency
            commissionTierType
            commissionTierValue
            bonusCommissionTierType
            bonusCommissionTierValue
            totalPrice
            creditNoteAmount
            creditNoteNumber
          }
        }
        totalCount
      }
    }
  `,
});

export const listLandlordReconciliationOpportunitiesCount = variables => ({
  operationName: 'LP_listLandlordReconciliationOpportunitiesCount',
  variables,
  query: `
    query LP_listLandlordReconciliationOpportunitiesCount(
      $finalMoveInDateEnd: VerifyDate,
      $finalMoveInDateStart: VerifyDate,
      $finalMoveOutDateEnd: VerifyDate,
      $finalMoveOutDateStart: VerifyDate,
      $completedAtEnd: Datetime,
      $completedAtStart: Datetime,
      $propertyIds: [ID],
    ) {
      readyForApprovalCount: listLandlordReconciliationOpportunities(
        finalMoveInDateEnd: $finalMoveInDateEnd,
        finalMoveInDateStart: $finalMoveInDateStart,
        finalMoveOutDateEnd: $finalMoveOutDateEnd,
        finalMoveOutDateStart: $finalMoveOutDateStart,
        completedAtEnd: $completedAtEnd,
        completedAtStart: $completedAtStart,
        landlordBookingStatus: READY_FOR_APPROVAL,
        propertyIds: $propertyIds,
      ) {
        totalCount
      }
      pendingApprovalCount: listLandlordReconciliationOpportunities(
        finalMoveInDateEnd: $finalMoveInDateEnd,
        finalMoveInDateStart: $finalMoveInDateStart,
        finalMoveOutDateEnd: $finalMoveOutDateEnd,
        finalMoveOutDateStart: $finalMoveOutDateStart,
        completedAtEnd: $completedAtEnd,
        completedAtStart: $completedAtStart,
        landlordBookingStatus: PENDING_APPROVAL,
        propertyIds: $propertyIds,
      ) {
        totalCount
      }
    }
    `,
});

export const getReconciliationLandlordProperties = variables => ({
  operationName: 'LP_GetReconciliationLandlordProperties',
  variables,
  query: `
    query LP_GetReconciliationLandlordProperties(
      $pageNumber: Int!,
      $pageSize: Int!,
      $statuses: [PropertyStatus!]
    ) {
      viewer {
        ... on LandlordContact {
          properties(
            pageSize: $pageSize,
            pageNumber: $pageNumber,
            statuses: $statuses,
          ) {
            edges {
              node {
                name
                slug
                id
                bookingJourney
              }
            }
          }
        }
      }
    }
  `,
});

export const getLandlordOpportunitiesPeriodReport = variables => ({
  operationName: 'LP_GetLandlordOpportunitiesPeriodReport',
  variables,
  query: `
    query LP_GetLandlordOpportunitiesPeriodReport(
      $completedAtEnd: Datetime,
      $completedAtStart: Datetime,
      $period: OpportunityReportPeriod!
      $propertyId: ID,
    ) {
      landlordOpportunitiesPeriodReport (
        completedAtEnd: $completedAtEnd,
        completedAtStart: $completedAtStart,
        period: $period,
        propertyId: $propertyId,
      ) {
        monthlyReport {
          count
          week
          month
        }
      }
    }
  `,
});

export const getReconciliationLandlordOpportunitiesOverview = variables => ({
  operationName: 'LP_GetReconciliationLandlordOpportunitiesOverview',
  variables,
  query: `
    query LP_GetReconciliationLandlordOpportunitiesOverview(
      $completedAtEnd: Datetime,
      $completedAtStart: Datetime,
      $propertyId: ID,
    ) {
      landlordOpportunitiesOverview (
        completedAtEnd: $completedAtEnd,
        completedAtStart: $completedAtStart,
        propertyId: $propertyId,
      ) {
        checkedIn
        comingSoon
        totalCount
        currencyGroup {
          currency
          totalCommission
        }
      }
    }
  `,
});

export const getReconciliationLandlordOpportunitiesStatusGroup = variables => ({
  operationName: 'LP_GetReconciliationLandlordOpportunitiesStatusGroup',
  variables,
  query: `
    query LP_GetReconciliationLandlordOpportunitiesStatusGroup(
      $dateAfter: Date,
      $dateBefore: Date,
      $propertyId: ID,
    ) {
      landlordOpportunitiesStatusGroup (
        dateAfter: $dateAfter,
        dateBefore: $dateBefore,
        propertyId: $propertyId,
      ) {
        landlordOpportunityStatusGroup {
          pendingApproval
          readyForApproval
          monthDate
        }
      }
    }
  `,
});

export const getReconciliationOpportunityDetails = variables => ({
  operationName: 'LP_GetReconciliationOpportunityDetails',
  variables,
  query: `
    query LP_GetReconciliationOpportunityDetails(
      $id: ID!,
    ) {
      getReconciliationOpportunityDetails (
        id: $id,
      ) {
        reconciliationOpportunityDetails {
          completedAt
          completedXbooking {
            billingCycle
            listingMoveIn
            listingMoveInType
            listingMoveOut
            listingMoveOutType
            propertyName
            referenceId
            roomName
            unitPrice
          }
          currency
          finalMoveInDate
          finalMoveOutDate
          finalPrice
          heroImage {
            source
          }
          id
          landlordApplicationId
          stage
          student {
            dateOfBirth
            destinationUniversity
            emailAddress
            gender
            nationality
            passportFirstName
            passportLastName
            passportMiddleName
            passportNumber
            phoneNumber
          }
        }
      }
    }
  `,
});

export const getReconciliationOpportunityDetailsStage = variables => ({
  operationName: 'LP_GetReconciliationOpportunityDetailsStage',
  variables,
  query: `
    query LP_GetReconciliationOpportunityDetailsStage(
      $id: ID!,
    ) {
      getReconciliationOpportunityDetails (
        id: $id,
      ) {
        reconciliationOpportunityDetails { 
          completedXbooking {
            commission {
              bonusValue
              currency
              totalCommissionValue
              value
              invoiceNumber
            }
          }
          landlordBookingStatus
          opportunityStateChanges{
            createdAt
            currentLandlordBookingStatus
            currentSecondaryLandlordBookingStatus
            id
            opportunityPendingNote {
              createdAt
              description
              id
              opportunityPendingNoteFiles {
                id
                name
                source
              }
              pendingNote
              updatedAt 
            } 
          }
        }
      }
    }
  `,
});

export const updateOpportunityLandlordBookingStatus = variables => ({
  operationName: 'LP_updateOpportunityLandlordBookingStatus',
  variables: {
    input: variables,
  },
  query: `
  mutation LP_updateOpportunityLandlordBookingStatus(
      $input: UpdateOpportunityLandlordBookingStatusInput,
    ) {
      updateOpportunityLandlordBookingStatus (
        input: $input,
      ) {
        result
      }
    }
  `,
});

export const checkActiveOpportunityCasesExist = variables => ({
  operationName: 'LP_checkActiveOpportunityCasesExist',
  variables: {
    input: variables,
  },
  query: `
  query LP_checkActiveOpportunityCasesExist(
      $input: CheckActiveOpportunityCasesExistInput,
    ) {
      checkActiveOpportunityCasesExist (
        input: $input,
      ) {
       exist
      }
    }
  `,
});

export const closeActiveOpportunityCases = variables => ({
  operationName: 'LP_closeActiveOpportunityCases',
  variables: {
    input: variables,
  },
  query: `
  mutation LP_closeActiveOpportunityCases(
      $input: CloseActiveOpportunityCasesInput,
    ) {
      closeActiveOpportunityCases (
        input: $input,
      ) {
        opportunityCases {
          id
        }
      }
    }
  `,
});

export const getPropertyTerms = variables => ({
  operationName: 'CMS_GetPropertyTerms',
  variables,
  query: `
    query CMS_GetPropertyTerms(
      $propertySlug: String!
      $sortBy: paymentTermsAndConditionsSortBy
      $sortDirection: SortDirection
    ) {
      property(slug: $propertySlug) {
        id
        slug
        name
        status
        city {
          slug
          country {
            slug
          }
        }
        paymentTermsAndConditions(
          statuses: [ACTIVE, INACTIVE, EXPIRED]
          sortBy: $sortBy
          sortDirection: $sortDirection
        ) {
          edges {
            node {
              id
              status
              title
              url
              fileName
              validFrom
              validTill
              createdAt
              updatedAt
            }
          }
        }
      }
    }`,
});

export const createPropertyTerms = variables => ({
  operationName: 'CMS_createPaymentsTermsAndConditions',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_createPaymentsTermsAndConditions($input: CreatePaymentsTermsAndConditionsInput!) {
      createPaymentsTermsAndConditions(input: $input) {
        termsAndConditions {
          id
        }
      }
    }
  `,
});

export const updatePropertyTerms = variables => ({
  operationName: 'CMS_updatePaymentsTermsAndConditions',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_updatePaymentsTermsAndConditions($input: UpdatePaymentsTermsAndConditionsInput!) {
      updatePaymentsTermsAndConditions(input: $input) {
        termsAndConditions {
          id
        }
      }
    }
  `,
});

export const deletePropertyTerms = variables => ({
  operationName: 'CMS_deletePaymentsTermsAndConditions',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_deletePaymentsTermsAndConditions($input: DeletePaymentsTermsAndConditionsInput!) {
      deletePaymentsTermsAndConditions(input: $input) {
        deletedPaymentsTermsAndConditionsId
      }
    }
  `,
});

export const uploadPaymentsTermsAndConditionsFile = `
  mutation CMS_uploadPaymentsTermsAndConditions($file: Upload) {
    uploadPaymentsTermsAndConditions(file: $file) {
      filename
      url
      contentType
    }
  }
`;

export const checkPropertyOfWithdrawMethod = variables => ({
  operationName: 'LP_CheckPropertyOfWithdrawMethod',
  variables,
  query: `
    query LP_CheckPropertyOfWithdrawMethod($properties: [WithdrawMethodBankPropertyInput]) {
      checkPropertyOfWithdrawMethod(properties: $properties) {
        result
      }
    }`,
});
